import { Container, Row, Col } from 'react-bootstrap';

function About() {
  return (
    <Container>
      <Row className='about-us' style={{ color: '#FFF' }}>
        <Col xs={12} sm={12} md={6} lg={6} className='about-us-col' style={{ textAlign: 'right' }}>
          <span className='about-us-text'>
            <span>O QUE<br /></span>
            <span className='about-us-title text-primary-color'>A GENTE PODE FAZER <br /> </span>
            <span>PELA SUA EMPRESA?</span>
          </span>
        </Col>
        <Col className='about-us-col'>
          <p className='about-us-description'>
            Somos uma <b>parceira valiosa para a sua empresa</b>, ajudando a definir identidade visual, artes gráficas, fotografia, vídeos, criar
            campanhas publicitárias, e desenvolver estratégias de marketing personalizadas, gerenciar presença nas mídias sociais e analisar dados
            para maximizar retorno sobre o investimento. <b>Resumindo somos o que você precisa!</b>
          </p>
        </Col>
      </Row>
    </Container>
  )
}

export default About